import { Typography } from 'antd';
import React from 'react';

const Post = () => {
  return (
    <Typography.Text type='warning' style={{ marginRight: '8px' }}>
      POST
    </Typography.Text>
  );
};

export default Post;
